<div class="terms-of-rental">
  <div class="container">
    <div class="header">
      <img loading="lazy" src="../../../../../assets/images/how-to-earn/header.jpg" alt="" />
      <div class="header__card">
        <div class="header__card--title">Kachiing Rental System Terms and Conditions</div>
        <div class="header__card--desc">Our platform is designed not only for convenience and community but also for providing multiple income-generating opportunities. Whether you're passionate about maintaining a safe digital space, helping businesses improve, or sharing your expertise, Kachiing offers diverse ways for you to earn.</div>
      </div>
    </div>

 
    
    <div>
      <h2 >1. Introduction</h2>
      <p>Welcome to Kachiing Rental System (“Kachiing”). By accessing or using our rental services, you agree to be bound by these Terms and Conditions (“Terms”). If you do not agree to these Terms, please do not use our services.</p>
     
      <section class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-md-6" *ngFor="let list of productList; let index = index">
              <div class="product-list-2">
                <img [src]="imgUrl + list?.image" />
                <div class="product-list-2__body">
                  <span class="product-list-2__body--meta">{{ list?.type | titlecase }} </span>
                  <div class="product-list-2__body--name">{{ list?.name }}</div>
                  <div class="product-list-2__body--desc">{{ list?.description }}</div>
                  <div class="product-list-2__body--price">${{ list?.price }} <span>/ Per Day</span></div>
                  <button class="my-button-3">View Product</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
      <h2>2. Definitions</h2>
      <ul>
        <li><strong>“Kachiing”</strong> refers to the Kachiing Rental System, including its website, mobile application, and any related services.</li>
        <li><strong>“User”</strong> refers to any individual or entity using the Kachiing services.</li>
        <li><strong>“Rental Item”</strong> refers to any item available for rent through Kachiing.</li>
        <li><strong>“Rental Period”</strong> refers to the duration for which a Rental Item is rented by the User.</li>
      </ul>
      <h2>3. Eligibility</h2>
      <ul>
        <li>Users must be at least 18 years old to use Kachiing services.</li>
        <li>Users must provide accurate, current, and complete information during the registration process.</li>
        <li>Users must have a valid payment method on file. (For rental of items above SGD$100)</li>
      </ul>
      <h2>4. Rental Agreement</h2>
      <ul>
        <li>By renting an item through Kachiing, Users enter into a rental agreement with Kachiing.</li>
        <li>The rental agreement includes the rental period, rental fee, and any applicable terms specific to the Rental Item.</li>
      </ul>
      <h2>5. Rental Period</h2>
      <ul>
        <li>The rental period begins when the User takes possession of the Rental Item.</li>
        <li>The rental period ends when the User returns the Rental Item to Kachiing.</li>
      </ul>
      <h2>6. Rental Fees and Payment</h2>
      <ul>
        <li>Rental fees are charged based on the duration of the rental period.</li>
        <li>Payment must be made in full before the rental period begins.</li>
        <li>Users are responsible for any additional charges incurred during the rental period, including late fees, damage fees, or replacement costs.</li>
      </ul>
      <h2>7. User Responsibilities</h2>
      <ul>
        <li>Users must use Rental Items in accordance with the provided instructions and guidelines.</li>
        <li>Users must not sublease or transfer possession of Rental Items to third parties.</li>
        <li>Users are responsible for maintaining the Rental Item in good condition and returning it in the same condition as when received.</li>
      </ul>
      <h2>8. Damage and Loss</h2>
      <ul>
        <li>Users are liable for any damage to or loss of the Rental Item during the rental period.</li>
        <li>In the event of damage or loss, Kachiing will attempt in good faith to facilitate resolution of the damage or loss, but is under no obligation to resolve the same. You agree to release Kachiing and to indemnify and hold Kachiing harmless from and against any claims, demands, liabilities and/or damage arising out of or in connection with your disputes with users of our Services.</li>
      </ul>
      <h2>9. Late Returns</h2>
      <ul>
        <li>Users must inform Kachiing, and the owners if they are unable to return a Rental Item on time.</li>
        <li>Late returns are subject to additional fees.</li>
        <li>If a product is past 23:59 if the last rental day, it will be considered as new rental and will be charged for an additional day.</li>
      </ul>
      <h2>10. Cancellation and Refunds</h2>
      <ul>
        <li>Users may cancel their rental reservation up to 4 hours before the rental period begins for a full refund.</li>
        <li>Cancellations made after the specified time are subject to a cancellation mark on your account, which may prevent you from using Kachiing rental systems in the future.</li>
        <li>There will be no refunds given once the items has been successfully handed over to the user.</li>
      </ul>
      <h2>11. Privacy Policy</h2>
      <ul>
        <li>Kachiing collects and uses User information in accordance with its Privacy Policy, which is available on our website.</li>
      </ul>
      <h2>12. Limitation of Liability</h2>
      <ul>
        <li>Kachiing is not liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the use of our services.</li>
        <li>Kachiing’s total liability for any claim arising out of or in connection with these Terms shall not exceed the rental fees paid by the User.</li>
      </ul>
      <h2>13. Governing Law</h2>
      <ul>
        <li>These Terms are governed by and construed in accordance with the laws of Singapore.</li>
        <li>Any disputes arising from these Terms shall be resolved in the courts of Singapore.</li>
      </ul>
      <h2>14. Amendments</h2>
      <ul>
        <li>Kachiing reserves the right to amend these Terms at any time without prior notice.</li>
      </ul>
    </div>
  </div>
</div>

<!-- <section>
  <div class="product-list" *ngFor="let list of productList; let index = index" [ngClass]="{ order: index % 2 }">
    <div class="container">
      <img [src]="imgUrl + list?.image" />
      <div class="product-list__body">
        <span class="product-list__body--meta">{{ list?.type | titlecase }} </span>
        <div class="product-list__body--name">{{ list?.name }}</div>
        <div class="product-list__body--desc">{{ list?.description }}</div>
        <div class="product-list__body--price">${{ list?.price }} <span>/ Per Day</span></div>
        <button class="my-button-3">View Product</button>
      </div>
    </div>
  </div>
</section> -->
